import { render } from "./WarehousesList.vue?vue&type=template&id=7ff336b0"
import script from "./WarehousesList.vue?vue&type=script&lang=js"
export * from "./WarehousesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__